import { Form } from '../core'

$.fn.NewsletterForm = function() {
  let self = this

  self.initialize_form = function() {
    new Form('.newsletter-form', {
      use_ajax: true,
      ajax_redirect: false,
      auto_scroll: true,
      auto_scroll_offset: $('header').outerHeight(false) + 20,
      floating_labels: true,
      onSuccess: function() {
      $('.newsletter-form').fadeOut('fast', function() {
          let $success = $('<p class="newsletter-form-success">')
          $success.text(site_l10n.FORM_NEWSLETTER_SUCCESS).hide()
          $('.newsletter-form').after($success)
          requestAnimationFrame(function() {
            $('.newsletter-form').remove()
            $success.fadeIn(250)
          })
        })
      },
    })
  }

  return function() {
    self.initialize_form()
    return self
  }()
}

$.fn.QuoteForm = function() {
  let self = this

  self.initialize_form = function() {
    new Form('.quote-form', {
      ajax_redirect: true,
      auto_scroll: true,
      auto_scroll_offset: $('header').outerHeight(false) + 20,
      floating_labels: false,
      locale: site_l10n.locale,
      date_picker: {
        dateFormat: "dd/mm/yy",
      },
      onSubmit: function() {
        $('.quote-form').addClass('quote-form--blocked')
      },
      onSuccess: function() {
        self.fadeOut(250, function() {
          let $success = $('<p class="form-success">')
          $success.text(site_l10n.FORM_QUOTE_SUCCESS).hide()
          self.after($success)
          requestAnimationFrame(function() {
            self.remove()
            $success.fadeIn(250)
          })
        })
      },
      onError: function() {
        requestAnimationFrame(function() {
          $('.quote-form').removeClass('quote-form--blocked')
          $('.quote-form .form-error--invisible').removeClass('form-error--invisible')
          $('.quote-form .field-error--invisible').removeClass('field-error--invisible')
        })
      },
    })
  }

  return function() {
    self.initialize_form()
    return self
  }()
}

$.fn.ContactForm = function() {
  let self = this

  self.initialize_form = function() {
    new Form('.contact-form', {
      ajax_redirect: site_l10n.site_id == '1',
      auto_scroll: true,
      auto_scroll_offset: $('header').outerHeight(false) + 20,
      floating_labels: true,
      onSubmit: function() {
        $('.contact-form').addClass('contact-form--blocked')
      },
      onSuccess: function() {
        self.fadeOut(250, function() {
          let $success = $('<p class="form-success">')
          $success.text(site_l10n.FORM_CONTACT_SUCCESS).hide()
          self.after($success)
          requestAnimationFrame(function() {
            self.remove()
            $success.fadeIn(250)
          })
        })
      },
      onError: function() {
        requestAnimationFrame(function() {
          $('.contact-form').removeClass('contact-form--blocked')
          $('.contact-form .form-error--invisible').removeClass('form-error--invisible')
          $('.contact-form .field-error--invisible').removeClass('field-error--invisible')
        })
      },
    })
  }

  return function() {
    self.initialize_form()
    return self
  }()
}

$.fn.ApplicationForm = function() {
  let self = this

  self.initialize_form = function() {
    new Form('.application-form', {
      ajax_redirect: true,
      auto_scroll: true,
      auto_scroll_offset: $('header').outerHeight(false) + 20,
      floating_labels: true,
      onSubmit: function() {
        $('.application-form').addClass('application-form--blocked')
      },
      onSuccess: function() {
        self.fadeOut(250, function() {
          let $success = $('<p class="form-success">')
          $success.text(site_l10n.FORM_JOB_SUCCESS).hide()
          self.after($success)
          requestAnimationFrame(function() {
            self.remove()
            $success.fadeIn(250)
          })
        })
      },
      onError: function() {
        requestAnimationFrame(function() {
          $('.application-form').removeClass('application-form--blocked')
          $('.application-form .form-error--invisible').removeClass('form-error--invisible')
          $('.application-form .field-error--invisible').removeClass('field-error--invisible')
        })
      },
    })
  }

  return function() {
    self.initialize_form()
    return self
  }()
}

$.fn.RetailerForm = function() {
  let self = this

  self.initialize_form = function() {
    new Form('.retailer-form', {
      use_ajax: true,
      ajax_redirect: false,
      auto_scroll: true,
      auto_scroll_offset: $('header').outerHeight(false) + 20,
      floating_labels: true,
      onSubmit: function() {
        $('.retailer-form').addClass('retailer-form--blocked')
      },
      onSuccess: function() {
        self.fadeOut(250, function() {
          let $success = $('<p class="form-success">')
          $success.text(site_l10n.FORM_CONTACT_SUCCESS).hide()
          self.after($success)
          requestAnimationFrame(function() {
            self.remove()
            $success.fadeIn(250)
          })
        })
      },
      onError: function() {
        requestAnimationFrame(function() {
          $('.retailer-form').removeClass('retailer-form--blocked')
          $('.retailer-form .form-error--invisible').removeClass('form-error--invisible')
          $('.retailer-form .field-error--invisible').removeClass('field-error--invisible')
        })
      },
    })
  }

  return function() {
    self.initialize_form()
    return self
  }()
}

$.fn.QuoteShortForm = function() {
  let self = this

  self.initialize_form = function() {
    new Form('.quote-short-form', {
      use_ajax: true,
      ajax_redirect: false,
      auto_scroll: true,
      auto_scroll_offset: $('header').outerHeight(false) + 20,
      floating_labels: true,
      onSubmit: function() {
        self.addClass('quote-short-form--blocked')
      },
      onSuccess: function() {
        self.fadeOut(250, function() {
          let $success = $('<p class="form-success">')
          $success.text(site_l10n.FORM_QUOTE_SUCCESS).hide()
          self.after($success)
          requestAnimationFrame(function() {
            self.remove()
            $success.fadeIn(250)
          })
        })
      },
      onError: function() {
        requestAnimationFrame(function() {
          self.removeClass('quote-short-form--blocked')
          self.find('.form-error--invisible').removeClass('form-error--invisible')
          self.find('.field-error--invisible').removeClass('field-error--invisible')
        })
      },
    })
  }

  return function() {
    self.initialize_form()
    return self
  }()
}

$.fn.CallBackForm = function() {
  let self = this

  self.initialize_form = function() {
    new Form('.call-back-form', {
      use_ajax: true,
      ajax_redirect: true,
      auto_scroll: true,
      auto_scroll_offset: $('header').outerHeight(false) + 20,
      floating_labels: true,
      onSubmit: function() {
        self.addClass('call-back-form--blocked')
      },
      onSuccess: function() {
        self.fadeOut(250, function() {
          let $success = $('<p class="form-success">')
          $success.text(site_l10n.FORM_QUOTE_SUCCESS).hide()
          self.after($success)
          requestAnimationFrame(function() {
            self.remove()
            $success.fadeIn(250)
          })
        })
      },
      onError: function() {
        requestAnimationFrame(function() {
          self.removeClass('call-back-form--blocked')
          self.find('.form-error--invisible').removeClass('form-error--invisible')
          self.find('.field-error--invisible').removeClass('field-error--invisible')
        })
      },
    })
  }

  return function() {
    self.initialize_form()
    return self
  }()
}

$.fn.QuickLeadForm = function() {
  let self = this

  self.initialize_form = function() {
    new Form('.quick-lead-form', {
      use_ajax: true,
      ajax_redirect: true,
      auto_scroll: true,
      auto_scroll_offset: $('header').outerHeight(false) + 20,
      floating_labels: true,
      onSubmit: function() {
        self.addClass('quick-lead-form--blocked')
      },
      onSuccess: function() {
        self.fadeOut(250, function() {
          let $success = $('<p class="form-success">')
          $success.text(site_l10n.FORM_QUOTE_SUCCESS).hide()
          self.after($success)
          requestAnimationFrame(function() {
            self.remove()
            $success.fadeIn(250)
          })
        })
      },
      onError: function() {
        requestAnimationFrame(function() {
          self.removeClass('quick-lead-form--blocked')
          self.find('.form-error--invisible').removeClass('form-error--invisible')
          self.find('.field-error--invisible').removeClass('field-error--invisible')
        })
      },
    })


  }

  return function() {
    self.initialize_form()
    return self
  }()
}

$.fn.RemoveNoChoice = function() {
  let self = this
  if (self.html() == 'Pas de préférence' ||
      self.html() == 'No preference') {
      self.addClass('hide-option')
  }

  return function() {
    return self
  }()
}
